import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { AlertCircleIcon } from 'lucide-react';
export function Urgency() {
  return <SectionWrapper className="bg-ink text-white text-center py-20" data-id="element-330">
      <div className="inline-flex items-center gap-2 text-coral mb-6" data-id="element-331">
        <AlertCircleIcon className="w-5 h-5" data-id="element-332" />
        <span className="font-sans font-bold uppercase tracking-wider text-sm" data-id="element-333">
          Precio de lanzamiento: $6,99
        </span>
      </div>

      <h2 className="font-sans text-3xl md:text-4xl font-bold mb-8" data-id="element-334">
        Este precio no es permanente.
      </h2>

      <div className="space-y-4 font-sans text-lg text-white/80 max-w-2xl mx-auto font-medium" data-id="element-335">
        <p data-id="element-336">
          Mientras el producto está en etapa de lanzamiento, el acceso está
          disponible a $6,99.
        </p>
        <p data-id="element-337">Cuando termine esta fase, el precio sube a $12,99.</p>
        <p className="font-bold text-white pt-4" data-id="element-338">
          Si estás viendo este precio, todavía está disponible.
        </p>
      </div>
    </SectionWrapper>;
}